// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.tenant-administrator-invoice-details-parent-container{
    position: absolute;
    top: 0;
    left: 0;
    width: 100%;
    padding: 5px;
    text-align: center;
}
.tenant-administrator-invoice-details-parent-container.default{
    opacity: 1;
    transform: translateX(0);
}
.tenant-administrator-invoice-details-parent-container.active{
    animation: tenant-administrator-invoice-details-parent-container-slide-in 0.4s ease-in forwards;
}
.tenant-administrator-invoice-details-parent-container.inactive{
    animation: tenant-administrator-invoice-details-parent-container-slide-out 0.4s ease-in forwards;
}
@keyframes tenant-administrator-invoice-details-parent-container-slide-in {
    from{
        opacity: 0;
        transform: translateX(-100%);
    }
    to{
        opacity: 1;
        transform: translateX(0);
    }
}
@keyframes tenant-administrator-invoice-details-parent-container-slide-out {
    from{
        opacity: 1;
        transform: translateX(0);
    }
    to{
        opacity: 0;
        transform: translateX(-100%);
    }
}
.tenant-administrator-invoice-details-issuing-invoice-container,
.tenant-administrator-invoice-details-deleting-invoice-container,
.tenant-administrator-invoice-details-cancelling-invoice-container{
    cursor: default;
    margin-top: 20vh;
    text-align: center;
}
.tenant-administrator-invoice-details-issuing-invoice-container div,
.tenant-administrator-invoice-details-deleting-invoice-container div,
.tenant-administrator-invoice-details-cancelling-invoice-container div{
    height: 32px;
    width: 32px;
    display: inline-block;
    border-radius: 50%;
    border: 2px solid rgba(155, 30, 30, 0.952);
    border-top-color: transparent;
}
.tenant-administrator-invoice-details-issuing-invoice-container div{
    animation: tenant-administrator-invoice-details-issuing-invoice-spinner 0.8s linear infinite;
}
@keyframes tenant-administrator-invoice-details-issuing-invoice-spinner {
    from{
        transform: rotate(0deg);
    }
    to{
        transform: rotate(360deg);
    }
}
.tenant-administrator-invoice-details-deleting-invoice-container div{
    animation: tenant-administrator-invoice-details-deleting-invoice-spinner 0.8s linear infinite;
}
@keyframes tenant-administrator-invoice-details-deleting-invoice-spinner {
    from{
        transform: rotate(0deg);
    }
    to{
        transform: rotate(360deg);
    }
}
.tenant-administrator-invoice-details-cancelling-invoice-container div{
    animation: tenant-administrator-invoice-details-cancelling-invoice-spinner 0.8s linear infinite;
}
@keyframes tenant-administrator-invoice-details-cancelling-invoice-spinner {
    from{
        transform: rotate(0deg);
    }
    to{
        transform: rotate(360deg);
    }
}
.tenant-administrator-invoice-details-issuing-invoice-container p,
.tenant-administrator-invoice-details-deleting-invoice-container p,
.tenant-administrator-invoice-details-cancelling-invoice-container p{
    color: rgb(48, 48, 48);
    font-family: 'Segoe UI', Tahoma, Geneva, Verdana, sans-serif;
}
.tenant-administrator-invoice-details-invoice-issued-container,
.tenant-administrator-invoice-details-invoice-deleted-container,
.tenant-administrator-invoice-details-invoice-cancelled-container{
    cursor: default;
    margin-top: 15vh;
    padding: 15px 25px;
    border-radius: 5px;
    display: inline-block;
    box-shadow: 0px 4px 8px rgba(0, 0, 0, 0.2);
}
.tenant-administrator-invoice-details-invoice-issued-container p,
.tenant-administrator-invoice-details-invoice-deleted-container p,
.tenant-administrator-invoice-details-invoice-cancelled-container p{
    margin: 16px 0px;
    font-size: 14px;
    color: rgb(48, 48, 48);
    font-family: Verdana, Geneva, Tahoma, sans-serif;
}
.tenant-administrator-invoice-details-invoice-issued-container div,
.tenant-administrator-invoice-details-invoice-deleted-container div,
.tenant-administrator-invoice-details-invoice-cancelled-container div{
    text-align: right;
}
.tenant-administrator-invoice-details-invoice-issued-container div button,
.tenant-administrator-invoice-details-invoice-deleted-container div button,
.tenant-administrator-invoice-details-invoice-cancelled-container div button{
    padding: 6px 12px;
    border: none;
    color: white;
    border-radius: 4px;
    cursor: pointer;
    background-color: rgba(155, 30, 30, 0.952);
    transition: background-color 0.15s ease-in;
}
.tenant-administrator-invoice-details-invoice-issued-container div button:hover,
.tenant-administrator-invoice-details-invoice-deleted-container div button:hover,
.tenant-administrator-invoice-details-invoice-cancelled-container div button:hover{
    background-color: rgba(194, 42, 42, 0.952);
}

/* #region Handle invoice payment and reversal*/
/* #region Loading billing account */
.tenant-administrator-invoice-details-invoice-payment-loading-account-container{
    cursor: default;
    margin-top: 20vh;
    text-align: center;
}
.tenant-administrator-invoice-details-invoice-payment-loading-account-container div{
    height: 32px;
    width: 32px;
    display: inline-block;
    border-radius: 50%;
    border: 2px solid rgba(155, 30, 30, 0.952);
    border-top-color: transparent;
    animation: tenant-administrator-invoice-details-invoice-payment-loading-account-spinner 0.8s linear infinite;
}
@keyframes tenant-administrator-invoice-details-invoice-payment-loading-account-spinner {
    from{
        transform: rotate(0deg);
    }
    to{
        transform: rotate(360deg);
    }
}
.tenant-administrator-invoice-details-invoice-payment-loading-account-container p{
    color: rgb(48, 48, 48);
    font-family: 'Segoe UI', Tahoma, Geneva, Verdana, sans-serif;
}
/* #endregion */
/* #region Insufficient funds */
.tenant-administrator-invoice-details-invoice-payment-insufficient-funds-container{
    text-align: left;
    display: inline-block;
    margin-top: 10vh;
    padding: 15px 20px;
    border-radius: 4px;
    box-shadow: 0px 8px 16px rgba(0, 0, 0, 0.2);
}
.tenant-administrator-invoice-details-invoice-payment-insufficient-funds-container p{
    margin: 4px 0px;
    font-size: 16px;
    font-family: 'Segoe UI', Tahoma, Geneva, Verdana, sans-serif;
}
.tenant-administrator-invoice-details-invoice-payment-insufficient-funds-container div{
    padding-top: 12px;
    padding-bottom: 5px;
    display: flex;
    justify-content: space-between;
}
.tenant-administrator-invoice-details-invoice-payment-insufficient-funds-container div button{
    padding: 8px 16px;
    cursor: pointer;
    border: none;
    border-radius: 4px;
    color: white;
    background-color: rgba(155, 30, 30, 0.952);
    transition: background-color 0.25s ease-in;
}
.tenant-administrator-invoice-details-invoice-payment-insufficient-funds-container div button:hover{
    background-color: rgb(199, 16, 16);
}
/* #endregion */
/* #region Payment confirmation*/
.tenant-administrator-invoice-details-invoice-payment-confirmation-container{
    text-align: center;
}
.tenant-administrator-invoice-details-invoice-payment-confirmation-container .details-parent-container{
    margin-top: 5vh;
    display: inline-block;
    padding: 16px 25px;
    border-radius: 5px;
    box-shadow: 0px 8px 16px rgba(0, 0, 0, 0.2);
}
.tenant-administrator-invoice-details-invoice-payment-confirmation-container .details-parent-container p{
    font-size: 15px;
    color: rgb(50, 50, 50);
    font-family: Verdana, Geneva, Tahoma, sans-serif;
}
.tenant-administrator-invoice-details-invoice-payment-confirmation-container .details-container{
    text-align: left;
    cursor: default;
    display: grid;
    row-gap: 4px;
    grid-template-columns: 200px 1fr;
    font-family: 'Segoe UI', Tahoma, Geneva, Verdana, sans-serif;
}
.tenant-administrator-invoice-details-invoice-payment-confirmation-container .details-container strong{
    font-weight: 500;
    color: rgb(48, 48, 48);
}
.tenant-administrator-invoice-details-invoice-payment-confirmation-container .details-container span{
    color: rgb(32, 32, 32);
    text-align: right;
}
.tenant-administrator-invoice-details-invoice-payment-confirmation-container .details-container strong.total,
.tenant-administrator-invoice-details-invoice-payment-confirmation-container .details-container span.total{
    padding: 4px 0px;
    border-top: 1px solid rgb(190, 190, 190);
    border-bottom: 1px solid rgb(190, 190, 190);
}
.tenant-administrator-invoice-details-invoice-payment-confirmation-container .details-container strong.available-balance,
.tenant-administrator-invoice-details-invoice-payment-confirmation-container .details-container span.available-balance{
    margin-top: 10px;
}
.tenant-administrator-invoice-details-invoice-payment-confirmation-container .details-container strong.remaining-balance,
.tenant-administrator-invoice-details-invoice-payment-confirmation-container .details-container span.remaining-balance{
    color: rgb(34, 102, 34);
}
.tenant-administrator-invoice-details-invoice-payment-confirmation-container .buttons-container{
    padding: 5px 0px;
    padding-top: 20px;
    display: flex;
    justify-content: space-between;
}
.tenant-administrator-invoice-details-invoice-payment-confirmation-container .buttons-container button{
    padding: 8px 16px;
    cursor: pointer;
    border: none;
    border-radius: 4px;
    color: white;
    background-color: rgba(155, 30, 30, 0.952);
    transition: background-color 0.25s ease-in;
}
.tenant-administrator-invoice-details-invoice-payment-confirmation-container .buttons-container button:hover{
    background-color: rgb(199, 16, 16);
}
/* #endregion*/
/* #region Processing payment*/
.tenant-administrator-invoice-details-processing-invoice-payment-container{
    cursor: default;
    margin-top: 20vh;
    text-align: center;
}
.tenant-administrator-invoice-details-processing-invoice-payment-container div{
    height: 32px;
    width: 32px;
    display: inline-block;
    border-radius: 50%;
    border: 2px solid rgba(155, 30, 30, 0.952);
    border-top-color: transparent;
    animation: tenant-administrator-invoice-details-processing-invoice-payment-spinner 0.8s linear infinite;
}
@keyframes tenant-administrator-invoice-details-processing-invoice-payment-spinner {
    from{
        transform: rotate(0deg);
    }
    to{
        transform: rotate(360deg);
    }
}
.tenant-administrator-invoice-details-processing-invoice-payment-container p{
    color: rgb(48, 48, 48);
    font-family: 'Segoe UI', Tahoma, Geneva, Verdana, sans-serif;
}
/* #endregion*/
/* #region Invoice payment processed*/
.tenant-administrator-invoice-details-invoice-payment-processed-container{
    margin-top: 10vh;
    display: inline-block;
    border-radius: 4px;
    padding: 10px 20px;
    box-shadow: 0px 8px 16px rgba(0, 0, 0, 0.2);
}
.tenant-administrator-invoice-details-invoice-payment-processed-container p{
    margin: 15px 0px;
    font-size: 15px;
    color: rgb(48, 48, 48);
    font-family: 'Segoe UI', Tahoma, Geneva, Verdana, sans-serif;
}
.tenant-administrator-invoice-details-invoice-payment-processed-container div{
    display: flex;
    justify-content: space-between;
    padding-top: 5px;
    padding-bottom: 10px;
}
.tenant-administrator-invoice-details-invoice-payment-processed-container div button{
    padding: 8px 16px;
    cursor: pointer;
    border: none;
    border-radius: 4px;
    color: white;
    background-color: rgba(155, 30, 30, 0.952);
    transition: background-color 0.25s ease-in;
}
.tenant-administrator-invoice-details-invoice-payment-processed-container div button:hover{
    background-color: rgba(204, 38, 38, 0.952);
}
/* #endregion*/
/* #region Invoice payment processing error*/
.tenant-administrator-invoice-details-invoice-payment-processing-error-container{
    margin-top: 10vh;
    display: inline-block;
    border-radius: 4px;
    padding: 10px 20px;
    box-shadow: 0px 8px 16px rgba(0, 0, 0, 0.2);
}
.tenant-administrator-invoice-details-invoice-payment-processing-error-container p{
    font-size: 15px;
    color: rgb(48, 48, 48);
    font-family: 'Segoe UI', Tahoma, Geneva, Verdana, sans-serif;
}
.tenant-administrator-invoice-details-invoice-payment-processing-error-container div{
    text-align: right;
    margin-bottom: 10px;
}
.tenant-administrator-invoice-details-invoice-payment-processing-error-container div button{
    padding: 8px 16px;
    cursor: pointer;
    border: none;
    border-radius: 4px;
    color: white;
    background-color: rgba(155, 30, 30, 0.952);
    transition: background-color 0.25s ease-in;
}
.tenant-administrator-invoice-details-invoice-payment-processing-error-container div button:hover{
    background-color: rgba(204, 38, 38, 0.952);
}
/* #endregion*/
/* #region Invoice payment reversing*/
.tenant-administrator-invoice-details-invoice-payment-reversing-container{
    cursor: default;
    margin-top: 20vh;
    text-align: center;
}
.tenant-administrator-invoice-details-invoice-payment-reversing-container div{
    height: 32px;
    width: 32px;
    display: inline-block;
    border-radius: 50%;
    border: 2px solid rgba(155, 30, 30, 0.952);
    border-top-color: transparent;
    animation: tenant-administrator-invoice-details-invoice-payment-reversing-spinner 0.8s linear infinite;
}
@keyframes tenant-administrator-invoice-details-invoice-payment-reversing-spinner {
    from{
        transform: rotate(0deg);
    }
    to{
        transform: rotate(360deg);
    }
}
.tenant-administrator-invoice-details-invoice-payment-reversing-container p{
    color: rgb(48, 48, 48);
    font-family: 'Segoe UI', Tahoma, Geneva, Verdana, sans-serif;
}
/* #endregion*/
/* #region Invoice payment reversed*/
.tenant-administrator-invoice-details-invoice-payment-reversed-container{
    margin-top: 10vh;
    display: inline-block;
    border-radius: 4px;
    padding: 10px 20px;
    box-shadow: 0px 8px 16px rgba(0, 0, 0, 0.2);
}
.tenant-administrator-invoice-details-invoice-payment-reversed-container p{
    font-size: 15px;
    color: rgb(48, 48, 48);
    font-family: 'Segoe UI', Tahoma, Geneva, Verdana, sans-serif;
}
.tenant-administrator-invoice-details-invoice-payment-reversed-container div{
    text-align: right;
}
.tenant-administrator-invoice-details-invoice-payment-reversed-container div button{
    padding: 8px 16px;
    cursor: pointer;
    border: none;
    border-radius: 4px;
    color: white;
    background-color: rgba(155, 30, 30, 0.952);
    transition: background-color 0.25s ease-in;
}
.tenant-administrator-invoice-details-invoice-payment-reversed-container div button:hover{
    background-color: rgba(204, 38, 38, 0.952);
}
/* #endregion*/
/* #region Invoice payment reverse error*/
.tenant-administrator-invoice-details-invoice-payment-reverse-error-container{
    margin-top: 10vh;
    display: inline-block;
    border-radius: 4px;
    padding: 10px 20px;
    box-shadow: 0px 8px 16px rgba(0, 0, 0, 0.2);
}
.tenant-administrator-invoice-details-invoice-payment-reverse-error-container p{
    font-size: 15px;
    color: rgb(48, 48, 48);
    font-family: 'Segoe UI', Tahoma, Geneva, Verdana, sans-serif;
}
.tenant-administrator-invoice-details-invoice-payment-reverse-error-container div{
    text-align: right;
    padding-bottom: 5px;
}
.tenant-administrator-invoice-details-invoice-payment-reverse-error-container div button{
    padding: 8px 16px;
    cursor: pointer;
    border: none;
    border-radius: 4px;
    color: white;
    background-color: rgba(155, 30, 30, 0.952);
    transition: background-color 0.25s ease-in;
}
.tenant-administrator-invoice-details-invoice-payment-reverse-error-container div button:hover{
    background-color: rgba(204, 38, 38, 0.952);
}
/* #endregion*/
/* #endregion */


.tenant-administrator-invoice-details-parent-navigation-bar{
    text-align: center;
    padding: 8px 0px;
    padding-bottom: 16px;
}
.tenant-administrator-invoice-details-parent-navigation-bar div{
    width: 70%;
    text-align: left;
    display: inline-block;
}
.tenant-administrator-invoice-details-parent-navigation-bar button{
    margin-right: 16px;
    padding: 6px 12px;
    border: none;
    color: white;
    border-radius: 5px;
    cursor: pointer;
    background-color: rgba(155, 30, 30, 0.952);
}
.tenant-administrator-invoice-details-container{
    position: relative;
    height: 60vh;
    width: 70%;
    text-align: left;
    display: inline-block;
    overflow: hidden;
    box-shadow: 0px 2px 8px 0px rgba(0, 0, 0, 0.2);
}
.tenant-administrator-invoice-details-edit-mask-container{
    position: absolute;
    z-index: 2;
    top: 0;
    left: 0;
    height: 100%;
    width: 100%;
    cursor: default;
    display: block;
    background-color: rgba(255, 255, 255, 0.5);
}
.tenant-administrator-invoice-details-edit-mask-container.hidden{
    display: none;
}
.tenant-administrator-invoice-details-navigation-bar{
    margin: 0px 25px;
    border-bottom: 1px solid rgb(226, 226, 226);
}
.tenant-administrator-invoice-details-navigation-bar button{
    border: none;
    padding: 0px 10px;
    padding-top: 10px;
    padding-bottom: 5px;
    cursor: pointer;
    color: rgb(100, 100, 100);
    font-size: 15px;
    font-weight: 500;
    font-family: 'Segoe UI', Tahoma, Geneva, Verdana, sans-serif;
    background-color: transparent;
}
.tenant-administrator-invoice-details-navigation-bar button.active{
    color: rgba(155, 30, 30, 0.952);
    border-bottom: 2px solid rgba(155, 30, 30, 0.952);
}
.tenant-administrator-invoice-details-primary-details-container{
    position: absolute;
    height: 90%;
    width: 100%;
    overflow: auto;
    padding: 10px 25px;
    padding-top: 0px;
    box-sizing: border-box;
}
.tenant-administrator-invoice-details-primary-details-container::-webkit-scrollbar{
    width: 4px;
}
.tenant-administrator-invoice-details-primary-details-container::-webkit-scrollbar-thumb{
    background-color: rgb(145, 145, 145);
    border-radius: 5px;
}
.tenant-administrator-invoice-details-primary-details-container.active{
    animation: tenant-administrator-invoice-details-primary-details-container-slide-in 0.5s ease-out forwards;
}
.tenant-administrator-invoice-details-primary-details-container.inactive{
    animation: tenant-administrator-invoice-details-primary-details-container-slide-out 0.5s ease-out forwards;
}
@keyframes tenant-administrator-invoice-details-primary-details-container-slide-in {
    from{
        opacity: 0;
        transform: translateX(100%);
    }
    to{
        opacity: 1;
        z-index: 1;
        transform: translateX(0);
    }
}
@keyframes tenant-administrator-invoice-details-primary-details-container-slide-out {
    from{
        opacity: 1;
        transform: translateX(0);
    }
    to{
        opacity: 0;
        z-index: 0;
        transform: translateX(110%);
    }
}
.tenant-administrator-invoice-details-entry-container{
    position: relative;
    margin: 20px 0px;
    padding: 4px 10px;
    box-sizing: border-box;
    border-bottom: 1px solid gray;
    border-radius: 2px 2px 0px 0px;
    background-color: rgba(222, 229, 233,0.6);
}
.tenant-administrator-invoice-details-entry-container:focus-within{
    border-bottom: 2px solid rgb(119, 12, 12);
    background-color: rgb(221, 232, 238);
}
.tenant-administrator-invoice-details-entry-container p{
    margin: 0px;
    font-size: 12px;
    cursor: default;
}
.tenant-administrator-invoice-details-entry-container span{
    color: red;
}
.tenant-administrator-invoice-details-entry-container input{
    width: 100%;
    outline: none;
    border: none;
    box-sizing: border-box;
    background-color: transparent;
}
.tenant-administrator-invoice-details-selected-customer-account-container{
    display: flex;
    align-items: center;
    justify-content: space-between;
}
.tenant-administrator-invoice-details-selected-customer-account-container p{
    cursor: default;
    font-size: 14px;
}
.tenant-administrator-invoice-details-selected-customer-account-container p span{
    cursor: pointer;
    margin-left: 16px;
    color: rgb(80, 80, 80);
}
.tenant-administrator-invoice-details-customer-account-browser{
    position: absolute;
    top: calc(100% + 2px);
    left: 0;
    width: 100%;
    max-height: 94px;
    z-index: 1;
    display: none;
    overflow: auto;
    box-sizing: border-box;
    background-color: white;
    box-shadow: 0px 4px 4px 0px rgba(0, 0, 0, 0.2);
}
.tenant-administrator-invoice-details-customer-account-browser.active{
    display: block;
}
.tenant-administrator-invoice-details-customer-account-browser div{
    display: flex;
    align-items: center;
    justify-content: space-between;
    font-size: 14px;
    padding: 10px 10px;
    cursor: pointer;
}
.tenant-administrator-invoice-details-customer-account-browser div:hover{
    background-color: rgb(243, 243, 243);
}
.tenant-administrator-invoice-details-selected-duration-type-container{
    display: flex;
    justify-content: space-between;
}
.tenant-administrator-invoice-details-selected-duration-type-container p{
    margin: 2px 0px;
    font-size: 14px;
}
.tenant-administrator-invoice-details-selected-duration-type-container .cancel-p{
    cursor: pointer;
    color: rgb(80, 80, 80);
}
.tenant-administrator-invoice-details-duration-type-browser{
    position: absolute;
    top: calc(100% + 2px);
    left: 0;
    width: 100%;
    z-index: 1;
    max-height: 104px;
    display: none;
    overflow: auto;
    box-sizing: border-box;
    background-color: white;
    box-shadow: 0px 4px 4px 0px rgba(0, 0, 0, 0.2);
}
.tenant-administrator-invoice-details-duration-type-browser.active{
    display: block;
}
.tenant-administrator-invoice-details-duration-type-browser div{
    cursor: pointer;
    font-size: 14px;
    padding: 8px 10px;
}
.tenant-administrator-invoice-details-duration-type-browser div:hover{
    background-color: rgb(243, 243, 243);
}
.tenant-administrator-invoice-details-duration-type-browser::-webkit-scrollbar{
    width: 4px;
}
.tenant-administrator-invoice-details-duration-type-browser::-webkit-scrollbar-thumb{
    border-radius: 5px;
    background-color: rgb(100, 100, 100);
}
.tenant-administrator-invoice-details-autogenerate-container{
    display: flex;
    align-items: center;
    margin-top: -5px;
    padding: 0px 5px;
    padding-bottom: 15px;
}
.tenant-administrator-invoice-details-autogenerate-container p{
    margin: 0px;
    margin-bottom: 4px;
    font-size: 14px;
}
.tenant-administrator-invoice-details-notes-container{
    padding: 10px;
    height: 15vh;
    display: flex;
    flex-direction: column;
    box-shadow: 0px 4px 8px 0px rgba(0, 0, 0, 0.2);
}
.tenant-administrator-invoice-details-notes-header{
    display: flex;
    align-items: center;
    justify-content: space-between;
    border-bottom: 1px solid lightgray;
}
.tenant-administrator-invoice-details-notes-header h3{
    margin: 0px 15px;
    font-size: 20px;
    font-weight: 500;
    cursor: default;
    color: rgb(100, 100, 100);
}
.tenant-administrator-invoice-details-notes-header p{
    margin: 0px 15px;
    font-size: 24px;
    font-weight: 500;
    cursor: pointer;
    color: rgb(100, 100, 100);
}
.tenant-administrator-invoice-details-notes-body{
    position: relative;
    overflow: auto;
    padding-top: 5px;
}
.tenant-administrator-invoice-details-notes-body::-webkit-scrollbar{
    width: 4px;
}
.tenant-administrator-invoice-details-notes-body::-webkit-scrollbar-thumb{
    border-radius: 5px;
    background-color: rgb(128, 128, 128);
}
.tenant-administrator-invoice-details-notes-body div{
    display: flex;
    padding: 5px 0px;
    margin: 5px 10px;
    border-radius: 4px;
}
.tenant-administrator-invoice-details-notes-body div.empty{
    border: 1px solid rgba(247, 0, 0, 0.507);
}
.tenant-administrator-invoice-details-notes-body div p{
    margin: 0px;
    margin-left: 5px;
}
.tenant-administrator-invoice-details-notes-body div input{
    width: 80%;
    margin-left: 10px;
    margin-right: 40px;
    border: none;
    outline: none;
}
.tenant-administrator-invoice-details-notes-body img{
    height: 20px;
    cursor: pointer;
}

.tenant-administrator-invoice-details-subscriptions-container{
    position: absolute;
    height: 50vh;
    width: calc(100% - 50px);
    margin: 10px 25px;
    padding: 10px 15px;
    box-sizing: border-box;
    box-shadow: 0px 2px 8px 0px rgba(0, 0, 0, 0.1);
}
.tenant-administrator-invoice-details-subscriptions-container.default{
    opacity: 0;
    z-index: 0;
    transform: translateX(110%);
}
.tenant-administrator-invoice-details-subscriptions-container.active{
    animation: tenant-administrator-invoice-details-subscriptions-container-slide-in 0.5s ease-out forwards;
}
.tenant-administrator-invoice-details-subscriptions-container.inactive{
    animation: tenant-administrator-invoice-details-subscriptions-container-slide-out 0.5s ease-out forwards;
}
@keyframes tenant-administrator-invoice-details-subscriptions-container-slide-in {
    from{
        opacity: 0;
        transform: translateX(100%);
    }
    to{
        opacity: 1;
        z-index: 1;
        transform: translateX(0);
    }
}

@keyframes tenant-administrator-invoice-details-subscriptions-container-slide-out {
    from{
        opacity: 1;
        transform: translateX(0);
    }
    to{
        opacity: 0;
        transform: translateX(110%);
    }
}
.tenant-administrator-invoice-details-subscriptions-header{
    padding-bottom: 5px;
    display: flex;
    align-items: center;
    justify-content: space-between;
    border-bottom: 1px solid rgb(240, 240, 240);
}
.tenant-administrator-invoice-details-subscriptions-header h3{
    margin: 0px;
    font-size: 20px;
    font-weight: 500;
    cursor: default;
    color: rgb(100, 100, 100);
}
.tenant-administrator-invoice-details-subscriptions-header p{
    margin: 0px;
    font-size: 24px;
    font-weight: 500;
    cursor: pointer;
    color: rgb(100, 100, 100);
}
.tenant-administrator-invoice-details-subscriptions-body{
    height: 100%;
}
.tenant-administrator-invoice-details-subscriptions-no-duration-type-parent-container{
    height: 80%;
    display: flex;
    align-items: center;
    justify-content: center;
    color: rgb(48, 48, 48);
}
.tenant-administrator-invoice-details-subscriptions-no-duration-type-container h2{
    font-weight: 500;
    font-size: 20px;
    text-align: center;
    margin: 10px 0px;
}
.tenant-administrator-invoice-details-subscriptions-no-duration-type-container p{
    font-size: 15px;
    margin: 0px;
}
.tenant-administrator-invoice-details-loading-available-subscriptions-parent-container{
    height: 80%;
    display: flex;
    align-items: center;
    justify-content: center;
}
.tenant-administrator-invoice-details-loading-available-subscriptions-container{
    text-align: center;
}
.tenant-administrator-invoice-details-loading-available-subscriptions-container div{
    width: 32px;
    height: 32px;
    display: inline-block;
    border: 2px solid rgba(0, 58, 97, 0.952);
    border-top-color: transparent;
    border-radius: 50%;
    animation: tenant-administrator-invoice-details-loading-available-subscriptions-spinner 1s linear infinite;
}
@keyframes tenant-administrator-invoice-details-loading-available-subscriptions-spinner {
    from{
        transform: rotate(0deg);
    }
    to{
        transform: rotate(360deg);
    }
}
.tenant-administrator-invoice-details-subscription-entries-container{
    height: 90%;
    overflow: auto;
}
.tenant-administrator-invoice-details-subscription-entries-container::-webkit-scrollbar{
    width: 4px;
}
.tenant-administrator-invoice-details-subscription-entries-container::-webkit-scrollbar-thumb{
    border-radius: 5px;
    background-color: gray;
}
.tenant-administrator-invoice-details-subscription-entry-container{
    display: flex;
    align-items: center;
    padding: 10px;
}
.tenant-administrator-invoice-details-subscription-entry-sub-container{
    width: 100%;
    position: relative;
}
.tenant-administrator-invoice-details-subscription-entry-value-container{
    display: grid;
    grid-template-columns: 4fr 1fr;
    padding: 4px 0px;
    border-bottom: 1px solid rgb(218, 218, 218);
}
.tenant-administrator-invoice-details-subscription-entry-value-container p{
    margin: 0px;
    cursor: default;
    font-size: 14px;
}
.tenant-administrator-invoice-details-subscription-entry-value-container div{
    display: flex;
    align-items: center;
    justify-content: space-between;
}
.tenant-administrator-invoice-details-subscription-entry-value-container div .remove-p{
    cursor: pointer;
    color: rgb(85, 85, 85);
}
.tenant-administrator-invoice-details-subscription-entry-container input{
    width: 100%;
    outline: none;
    border: none;
    box-sizing: border-box;
    border-bottom: 1px solid rgb(190, 190, 190);
}
.tenant-administrator-invoice-details-subscription-entry-container input:focus{
    border-bottom: 1px solid rgba(180, 0, 0, 0.507);
}
.tenant-administrator-invoice-details-subscription-entry-container img{
    height: 25px;
    margin-left: 10px;
    cursor: pointer;
}
.tenant-administrator-invoice-details-subscriptions-browser{
    position: absolute;
    z-index: 1;
    top: calc(100% + 2px);
    left: 0;
    width: 100%;
    max-height: 16.5vh;
    display: none;
    overflow: auto;
    box-sizing: border-box;
    background-color: white;
    box-shadow: 0px 2px 4px 0px rgba(0, 0, 0, 0.2);
}
.tenant-administrator-invoice-details-subscriptions-browser::-webkit-scrollbar{
    width: 4px;
}
.tenant-administrator-invoice-details-subscriptions-browser::-webkit-scrollbar-thumb{
    border-radius: 5px;
    background-color: rgb(128, 128, 128);
}
.tenant-administrator-invoice-details-subscriptions-browser.active{
    display: block;
}
.tenant-administrator-invoice-details-subscriptions-browser div{
    cursor: pointer;
    display: grid;
    grid-template-columns: 4fr 1fr;
    border-bottom: 1px solid rgb(235, 235, 235);
}
.tenant-administrator-invoice-details-subscriptions-browser div:hover{
    background-color: rgb(235, 235, 235);
}
.tenant-administrator-invoice-details-subscriptions-browser div p{
    margin: 6px 10px;
    font-size: 14px;
    color: rgb(48, 48, 48);
}`, "",{"version":3,"sources":["webpack://./src/styles/workspace_styles/TenantAdministratorStyles/Invoices/Invoice/InvoiceDetails.css"],"names":[],"mappings":"AAAA;IACI,kBAAkB;IAClB,MAAM;IACN,OAAO;IACP,WAAW;IACX,YAAY;IACZ,kBAAkB;AACtB;AACA;IACI,UAAU;IACV,wBAAwB;AAC5B;AACA;IACI,+FAA+F;AACnG;AACA;IACI,gGAAgG;AACpG;AACA;IACI;QACI,UAAU;QACV,4BAA4B;IAChC;IACA;QACI,UAAU;QACV,wBAAwB;IAC5B;AACJ;AACA;IACI;QACI,UAAU;QACV,wBAAwB;IAC5B;IACA;QACI,UAAU;QACV,4BAA4B;IAChC;AACJ;AACA;;;IAGI,eAAe;IACf,gBAAgB;IAChB,kBAAkB;AACtB;AACA;;;IAGI,YAAY;IACZ,WAAW;IACX,qBAAqB;IACrB,kBAAkB;IAClB,0CAA0C;IAC1C,6BAA6B;AACjC;AACA;IACI,4FAA4F;AAChG;AACA;IACI;QACI,uBAAuB;IAC3B;IACA;QACI,yBAAyB;IAC7B;AACJ;AACA;IACI,6FAA6F;AACjG;AACA;IACI;QACI,uBAAuB;IAC3B;IACA;QACI,yBAAyB;IAC7B;AACJ;AACA;IACI,+FAA+F;AACnG;AACA;IACI;QACI,uBAAuB;IAC3B;IACA;QACI,yBAAyB;IAC7B;AACJ;AACA;;;IAGI,sBAAsB;IACtB,4DAA4D;AAChE;AACA;;;IAGI,eAAe;IACf,gBAAgB;IAChB,kBAAkB;IAClB,kBAAkB;IAClB,qBAAqB;IACrB,0CAA0C;AAC9C;AACA;;;IAGI,gBAAgB;IAChB,eAAe;IACf,sBAAsB;IACtB,gDAAgD;AACpD;AACA;;;IAGI,iBAAiB;AACrB;AACA;;;IAGI,iBAAiB;IACjB,YAAY;IACZ,YAAY;IACZ,kBAAkB;IAClB,eAAe;IACf,0CAA0C;IAC1C,0CAA0C;AAC9C;AACA;;;IAGI,0CAA0C;AAC9C;;AAEA,+CAA+C;AAC/C,oCAAoC;AACpC;IACI,eAAe;IACf,gBAAgB;IAChB,kBAAkB;AACtB;AACA;IACI,YAAY;IACZ,WAAW;IACX,qBAAqB;IACrB,kBAAkB;IAClB,0CAA0C;IAC1C,6BAA6B;IAC7B,4GAA4G;AAChH;AACA;IACI;QACI,uBAAuB;IAC3B;IACA;QACI,yBAAyB;IAC7B;AACJ;AACA;IACI,sBAAsB;IACtB,4DAA4D;AAChE;AACA,eAAe;AACf,+BAA+B;AAC/B;IACI,gBAAgB;IAChB,qBAAqB;IACrB,gBAAgB;IAChB,kBAAkB;IAClB,kBAAkB;IAClB,2CAA2C;AAC/C;AACA;IACI,eAAe;IACf,eAAe;IACf,4DAA4D;AAChE;AACA;IACI,iBAAiB;IACjB,mBAAmB;IACnB,aAAa;IACb,8BAA8B;AAClC;AACA;IACI,iBAAiB;IACjB,eAAe;IACf,YAAY;IACZ,kBAAkB;IAClB,YAAY;IACZ,0CAA0C;IAC1C,0CAA0C;AAC9C;AACA;IACI,kCAAkC;AACtC;AACA,eAAe;AACf,gCAAgC;AAChC;IACI,kBAAkB;AACtB;AACA;IACI,eAAe;IACf,qBAAqB;IACrB,kBAAkB;IAClB,kBAAkB;IAClB,2CAA2C;AAC/C;AACA;IACI,eAAe;IACf,sBAAsB;IACtB,gDAAgD;AACpD;AACA;IACI,gBAAgB;IAChB,eAAe;IACf,aAAa;IACb,YAAY;IACZ,gCAAgC;IAChC,4DAA4D;AAChE;AACA;IACI,gBAAgB;IAChB,sBAAsB;AAC1B;AACA;IACI,sBAAsB;IACtB,iBAAiB;AACrB;AACA;;IAEI,gBAAgB;IAChB,wCAAwC;IACxC,2CAA2C;AAC/C;AACA;;IAEI,gBAAgB;AACpB;AACA;;IAEI,uBAAuB;AAC3B;AACA;IACI,gBAAgB;IAChB,iBAAiB;IACjB,aAAa;IACb,8BAA8B;AAClC;AACA;IACI,iBAAiB;IACjB,eAAe;IACf,YAAY;IACZ,kBAAkB;IAClB,YAAY;IACZ,0CAA0C;IAC1C,0CAA0C;AAC9C;AACA;IACI,kCAAkC;AACtC;AACA,cAAc;AACd,8BAA8B;AAC9B;IACI,eAAe;IACf,gBAAgB;IAChB,kBAAkB;AACtB;AACA;IACI,YAAY;IACZ,WAAW;IACX,qBAAqB;IACrB,kBAAkB;IAClB,0CAA0C;IAC1C,6BAA6B;IAC7B,uGAAuG;AAC3G;AACA;IACI;QACI,uBAAuB;IAC3B;IACA;QACI,yBAAyB;IAC7B;AACJ;AACA;IACI,sBAAsB;IACtB,4DAA4D;AAChE;AACA,cAAc;AACd,qCAAqC;AACrC;IACI,gBAAgB;IAChB,qBAAqB;IACrB,kBAAkB;IAClB,kBAAkB;IAClB,2CAA2C;AAC/C;AACA;IACI,gBAAgB;IAChB,eAAe;IACf,sBAAsB;IACtB,4DAA4D;AAChE;AACA;IACI,aAAa;IACb,8BAA8B;IAC9B,gBAAgB;IAChB,oBAAoB;AACxB;AACA;IACI,iBAAiB;IACjB,eAAe;IACf,YAAY;IACZ,kBAAkB;IAClB,YAAY;IACZ,0CAA0C;IAC1C,0CAA0C;AAC9C;AACA;IACI,0CAA0C;AAC9C;AACA,cAAc;AACd,4CAA4C;AAC5C;IACI,gBAAgB;IAChB,qBAAqB;IACrB,kBAAkB;IAClB,kBAAkB;IAClB,2CAA2C;AAC/C;AACA;IACI,eAAe;IACf,sBAAsB;IACtB,4DAA4D;AAChE;AACA;IACI,iBAAiB;IACjB,mBAAmB;AACvB;AACA;IACI,iBAAiB;IACjB,eAAe;IACf,YAAY;IACZ,kBAAkB;IAClB,YAAY;IACZ,0CAA0C;IAC1C,0CAA0C;AAC9C;AACA;IACI,0CAA0C;AAC9C;AACA,cAAc;AACd,qCAAqC;AACrC;IACI,eAAe;IACf,gBAAgB;IAChB,kBAAkB;AACtB;AACA;IACI,YAAY;IACZ,WAAW;IACX,qBAAqB;IACrB,kBAAkB;IAClB,0CAA0C;IAC1C,6BAA6B;IAC7B,sGAAsG;AAC1G;AACA;IACI;QACI,uBAAuB;IAC3B;IACA;QACI,yBAAyB;IAC7B;AACJ;AACA;IACI,sBAAsB;IACtB,4DAA4D;AAChE;AACA,cAAc;AACd,oCAAoC;AACpC;IACI,gBAAgB;IAChB,qBAAqB;IACrB,kBAAkB;IAClB,kBAAkB;IAClB,2CAA2C;AAC/C;AACA;IACI,eAAe;IACf,sBAAsB;IACtB,4DAA4D;AAChE;AACA;IACI,iBAAiB;AACrB;AACA;IACI,iBAAiB;IACjB,eAAe;IACf,YAAY;IACZ,kBAAkB;IAClB,YAAY;IACZ,0CAA0C;IAC1C,0CAA0C;AAC9C;AACA;IACI,0CAA0C;AAC9C;AACA,cAAc;AACd,yCAAyC;AACzC;IACI,gBAAgB;IAChB,qBAAqB;IACrB,kBAAkB;IAClB,kBAAkB;IAClB,2CAA2C;AAC/C;AACA;IACI,eAAe;IACf,sBAAsB;IACtB,4DAA4D;AAChE;AACA;IACI,iBAAiB;IACjB,mBAAmB;AACvB;AACA;IACI,iBAAiB;IACjB,eAAe;IACf,YAAY;IACZ,kBAAkB;IAClB,YAAY;IACZ,0CAA0C;IAC1C,0CAA0C;AAC9C;AACA;IACI,0CAA0C;AAC9C;AACA,cAAc;AACd,eAAe;;;AAGf;IACI,kBAAkB;IAClB,gBAAgB;IAChB,oBAAoB;AACxB;AACA;IACI,UAAU;IACV,gBAAgB;IAChB,qBAAqB;AACzB;AACA;IACI,kBAAkB;IAClB,iBAAiB;IACjB,YAAY;IACZ,YAAY;IACZ,kBAAkB;IAClB,eAAe;IACf,0CAA0C;AAC9C;AACA;IACI,kBAAkB;IAClB,YAAY;IACZ,UAAU;IACV,gBAAgB;IAChB,qBAAqB;IACrB,gBAAgB;IAChB,8CAA8C;AAClD;AACA;IACI,kBAAkB;IAClB,UAAU;IACV,MAAM;IACN,OAAO;IACP,YAAY;IACZ,WAAW;IACX,eAAe;IACf,cAAc;IACd,0CAA0C;AAC9C;AACA;IACI,aAAa;AACjB;AACA;IACI,gBAAgB;IAChB,2CAA2C;AAC/C;AACA;IACI,YAAY;IACZ,iBAAiB;IACjB,iBAAiB;IACjB,mBAAmB;IACnB,eAAe;IACf,yBAAyB;IACzB,eAAe;IACf,gBAAgB;IAChB,4DAA4D;IAC5D,6BAA6B;AACjC;AACA;IACI,+BAA+B;IAC/B,iDAAiD;AACrD;AACA;IACI,kBAAkB;IAClB,WAAW;IACX,WAAW;IACX,cAAc;IACd,kBAAkB;IAClB,gBAAgB;IAChB,sBAAsB;AAC1B;AACA;IACI,UAAU;AACd;AACA;IACI,oCAAoC;IACpC,kBAAkB;AACtB;AACA;IACI,yGAAyG;AAC7G;AACA;IACI,0GAA0G;AAC9G;AACA;IACI;QACI,UAAU;QACV,2BAA2B;IAC/B;IACA;QACI,UAAU;QACV,UAAU;QACV,wBAAwB;IAC5B;AACJ;AACA;IACI;QACI,UAAU;QACV,wBAAwB;IAC5B;IACA;QACI,UAAU;QACV,UAAU;QACV,2BAA2B;IAC/B;AACJ;AACA;IACI,kBAAkB;IAClB,gBAAgB;IAChB,iBAAiB;IACjB,sBAAsB;IACtB,6BAA6B;IAC7B,8BAA8B;IAC9B,yCAAyC;AAC7C;AACA;IACI,yCAAyC;IACzC,oCAAoC;AACxC;AACA;IACI,WAAW;IACX,eAAe;IACf,eAAe;AACnB;AACA;IACI,UAAU;AACd;AACA;IACI,WAAW;IACX,aAAa;IACb,YAAY;IACZ,sBAAsB;IACtB,6BAA6B;AACjC;AACA;IACI,aAAa;IACb,mBAAmB;IACnB,8BAA8B;AAClC;AACA;IACI,eAAe;IACf,eAAe;AACnB;AACA;IACI,eAAe;IACf,iBAAiB;IACjB,sBAAsB;AAC1B;AACA;IACI,kBAAkB;IAClB,qBAAqB;IACrB,OAAO;IACP,WAAW;IACX,gBAAgB;IAChB,UAAU;IACV,aAAa;IACb,cAAc;IACd,sBAAsB;IACtB,uBAAuB;IACvB,8CAA8C;AAClD;AACA;IACI,cAAc;AAClB;AACA;IACI,aAAa;IACb,mBAAmB;IACnB,8BAA8B;IAC9B,eAAe;IACf,kBAAkB;IAClB,eAAe;AACnB;AACA;IACI,oCAAoC;AACxC;AACA;IACI,aAAa;IACb,8BAA8B;AAClC;AACA;IACI,eAAe;IACf,eAAe;AACnB;AACA;IACI,eAAe;IACf,sBAAsB;AAC1B;AACA;IACI,kBAAkB;IAClB,qBAAqB;IACrB,OAAO;IACP,WAAW;IACX,UAAU;IACV,iBAAiB;IACjB,aAAa;IACb,cAAc;IACd,sBAAsB;IACtB,uBAAuB;IACvB,8CAA8C;AAClD;AACA;IACI,cAAc;AAClB;AACA;IACI,eAAe;IACf,eAAe;IACf,iBAAiB;AACrB;AACA;IACI,oCAAoC;AACxC;AACA;IACI,UAAU;AACd;AACA;IACI,kBAAkB;IAClB,oCAAoC;AACxC;AACA;IACI,aAAa;IACb,mBAAmB;IACnB,gBAAgB;IAChB,gBAAgB;IAChB,oBAAoB;AACxB;AACA;IACI,WAAW;IACX,kBAAkB;IAClB,eAAe;AACnB;AACA;IACI,aAAa;IACb,YAAY;IACZ,aAAa;IACb,sBAAsB;IACtB,8CAA8C;AAClD;AACA;IACI,aAAa;IACb,mBAAmB;IACnB,8BAA8B;IAC9B,kCAAkC;AACtC;AACA;IACI,gBAAgB;IAChB,eAAe;IACf,gBAAgB;IAChB,eAAe;IACf,yBAAyB;AAC7B;AACA;IACI,gBAAgB;IAChB,eAAe;IACf,gBAAgB;IAChB,eAAe;IACf,yBAAyB;AAC7B;AACA;IACI,kBAAkB;IAClB,cAAc;IACd,gBAAgB;AACpB;AACA;IACI,UAAU;AACd;AACA;IACI,kBAAkB;IAClB,oCAAoC;AACxC;AACA;IACI,aAAa;IACb,gBAAgB;IAChB,gBAAgB;IAChB,kBAAkB;AACtB;AACA;IACI,wCAAwC;AAC5C;AACA;IACI,WAAW;IACX,gBAAgB;AACpB;AACA;IACI,UAAU;IACV,iBAAiB;IACjB,kBAAkB;IAClB,YAAY;IACZ,aAAa;AACjB;AACA;IACI,YAAY;IACZ,eAAe;AACnB;;AAEA;IACI,kBAAkB;IAClB,YAAY;IACZ,wBAAwB;IACxB,iBAAiB;IACjB,kBAAkB;IAClB,sBAAsB;IACtB,8CAA8C;AAClD;AACA;IACI,UAAU;IACV,UAAU;IACV,2BAA2B;AAC/B;AACA;IACI,uGAAuG;AAC3G;AACA;IACI,wGAAwG;AAC5G;AACA;IACI;QACI,UAAU;QACV,2BAA2B;IAC/B;IACA;QACI,UAAU;QACV,UAAU;QACV,wBAAwB;IAC5B;AACJ;;AAEA;IACI;QACI,UAAU;QACV,wBAAwB;IAC5B;IACA;QACI,UAAU;QACV,2BAA2B;IAC/B;AACJ;AACA;IACI,mBAAmB;IACnB,aAAa;IACb,mBAAmB;IACnB,8BAA8B;IAC9B,2CAA2C;AAC/C;AACA;IACI,WAAW;IACX,eAAe;IACf,gBAAgB;IAChB,eAAe;IACf,yBAAyB;AAC7B;AACA;IACI,WAAW;IACX,eAAe;IACf,gBAAgB;IAChB,eAAe;IACf,yBAAyB;AAC7B;AACA;IACI,YAAY;AAChB;AACA;IACI,WAAW;IACX,aAAa;IACb,mBAAmB;IACnB,uBAAuB;IACvB,sBAAsB;AAC1B;AACA;IACI,gBAAgB;IAChB,eAAe;IACf,kBAAkB;IAClB,gBAAgB;AACpB;AACA;IACI,eAAe;IACf,WAAW;AACf;AACA;IACI,WAAW;IACX,aAAa;IACb,mBAAmB;IACnB,uBAAuB;AAC3B;AACA;IACI,kBAAkB;AACtB;AACA;IACI,WAAW;IACX,YAAY;IACZ,qBAAqB;IACrB,wCAAwC;IACxC,6BAA6B;IAC7B,kBAAkB;IAClB,0GAA0G;AAC9G;AACA;IACI;QACI,uBAAuB;IAC3B;IACA;QACI,yBAAyB;IAC7B;AACJ;AACA;IACI,WAAW;IACX,cAAc;AAClB;AACA;IACI,UAAU;AACd;AACA;IACI,kBAAkB;IAClB,sBAAsB;AAC1B;AACA;IACI,aAAa;IACb,mBAAmB;IACnB,aAAa;AACjB;AACA;IACI,WAAW;IACX,kBAAkB;AACtB;AACA;IACI,aAAa;IACb,8BAA8B;IAC9B,gBAAgB;IAChB,2CAA2C;AAC/C;AACA;IACI,WAAW;IACX,eAAe;IACf,eAAe;AACnB;AACA;IACI,aAAa;IACb,mBAAmB;IACnB,8BAA8B;AAClC;AACA;IACI,eAAe;IACf,sBAAsB;AAC1B;AACA;IACI,WAAW;IACX,aAAa;IACb,YAAY;IACZ,sBAAsB;IACtB,2CAA2C;AAC/C;AACA;IACI,+CAA+C;AACnD;AACA;IACI,YAAY;IACZ,iBAAiB;IACjB,eAAe;AACnB;AACA;IACI,kBAAkB;IAClB,UAAU;IACV,qBAAqB;IACrB,OAAO;IACP,WAAW;IACX,kBAAkB;IAClB,aAAa;IACb,cAAc;IACd,sBAAsB;IACtB,uBAAuB;IACvB,8CAA8C;AAClD;AACA;IACI,UAAU;AACd;AACA;IACI,kBAAkB;IAClB,oCAAoC;AACxC;AACA;IACI,cAAc;AAClB;AACA;IACI,eAAe;IACf,aAAa;IACb,8BAA8B;IAC9B,2CAA2C;AAC/C;AACA;IACI,oCAAoC;AACxC;AACA;IACI,gBAAgB;IAChB,eAAe;IACf,sBAAsB;AAC1B","sourcesContent":[".tenant-administrator-invoice-details-parent-container{\n    position: absolute;\n    top: 0;\n    left: 0;\n    width: 100%;\n    padding: 5px;\n    text-align: center;\n}\n.tenant-administrator-invoice-details-parent-container.default{\n    opacity: 1;\n    transform: translateX(0);\n}\n.tenant-administrator-invoice-details-parent-container.active{\n    animation: tenant-administrator-invoice-details-parent-container-slide-in 0.4s ease-in forwards;\n}\n.tenant-administrator-invoice-details-parent-container.inactive{\n    animation: tenant-administrator-invoice-details-parent-container-slide-out 0.4s ease-in forwards;\n}\n@keyframes tenant-administrator-invoice-details-parent-container-slide-in {\n    from{\n        opacity: 0;\n        transform: translateX(-100%);\n    }\n    to{\n        opacity: 1;\n        transform: translateX(0);\n    }\n}\n@keyframes tenant-administrator-invoice-details-parent-container-slide-out {\n    from{\n        opacity: 1;\n        transform: translateX(0);\n    }\n    to{\n        opacity: 0;\n        transform: translateX(-100%);\n    }\n}\n.tenant-administrator-invoice-details-issuing-invoice-container,\n.tenant-administrator-invoice-details-deleting-invoice-container,\n.tenant-administrator-invoice-details-cancelling-invoice-container{\n    cursor: default;\n    margin-top: 20vh;\n    text-align: center;\n}\n.tenant-administrator-invoice-details-issuing-invoice-container div,\n.tenant-administrator-invoice-details-deleting-invoice-container div,\n.tenant-administrator-invoice-details-cancelling-invoice-container div{\n    height: 32px;\n    width: 32px;\n    display: inline-block;\n    border-radius: 50%;\n    border: 2px solid rgba(155, 30, 30, 0.952);\n    border-top-color: transparent;\n}\n.tenant-administrator-invoice-details-issuing-invoice-container div{\n    animation: tenant-administrator-invoice-details-issuing-invoice-spinner 0.8s linear infinite;\n}\n@keyframes tenant-administrator-invoice-details-issuing-invoice-spinner {\n    from{\n        transform: rotate(0deg);\n    }\n    to{\n        transform: rotate(360deg);\n    }\n}\n.tenant-administrator-invoice-details-deleting-invoice-container div{\n    animation: tenant-administrator-invoice-details-deleting-invoice-spinner 0.8s linear infinite;\n}\n@keyframes tenant-administrator-invoice-details-deleting-invoice-spinner {\n    from{\n        transform: rotate(0deg);\n    }\n    to{\n        transform: rotate(360deg);\n    }\n}\n.tenant-administrator-invoice-details-cancelling-invoice-container div{\n    animation: tenant-administrator-invoice-details-cancelling-invoice-spinner 0.8s linear infinite;\n}\n@keyframes tenant-administrator-invoice-details-cancelling-invoice-spinner {\n    from{\n        transform: rotate(0deg);\n    }\n    to{\n        transform: rotate(360deg);\n    }\n}\n.tenant-administrator-invoice-details-issuing-invoice-container p,\n.tenant-administrator-invoice-details-deleting-invoice-container p,\n.tenant-administrator-invoice-details-cancelling-invoice-container p{\n    color: rgb(48, 48, 48);\n    font-family: 'Segoe UI', Tahoma, Geneva, Verdana, sans-serif;\n}\n.tenant-administrator-invoice-details-invoice-issued-container,\n.tenant-administrator-invoice-details-invoice-deleted-container,\n.tenant-administrator-invoice-details-invoice-cancelled-container{\n    cursor: default;\n    margin-top: 15vh;\n    padding: 15px 25px;\n    border-radius: 5px;\n    display: inline-block;\n    box-shadow: 0px 4px 8px rgba(0, 0, 0, 0.2);\n}\n.tenant-administrator-invoice-details-invoice-issued-container p,\n.tenant-administrator-invoice-details-invoice-deleted-container p,\n.tenant-administrator-invoice-details-invoice-cancelled-container p{\n    margin: 16px 0px;\n    font-size: 14px;\n    color: rgb(48, 48, 48);\n    font-family: Verdana, Geneva, Tahoma, sans-serif;\n}\n.tenant-administrator-invoice-details-invoice-issued-container div,\n.tenant-administrator-invoice-details-invoice-deleted-container div,\n.tenant-administrator-invoice-details-invoice-cancelled-container div{\n    text-align: right;\n}\n.tenant-administrator-invoice-details-invoice-issued-container div button,\n.tenant-administrator-invoice-details-invoice-deleted-container div button,\n.tenant-administrator-invoice-details-invoice-cancelled-container div button{\n    padding: 6px 12px;\n    border: none;\n    color: white;\n    border-radius: 4px;\n    cursor: pointer;\n    background-color: rgba(155, 30, 30, 0.952);\n    transition: background-color 0.15s ease-in;\n}\n.tenant-administrator-invoice-details-invoice-issued-container div button:hover,\n.tenant-administrator-invoice-details-invoice-deleted-container div button:hover,\n.tenant-administrator-invoice-details-invoice-cancelled-container div button:hover{\n    background-color: rgba(194, 42, 42, 0.952);\n}\n\n/* #region Handle invoice payment and reversal*/\n/* #region Loading billing account */\n.tenant-administrator-invoice-details-invoice-payment-loading-account-container{\n    cursor: default;\n    margin-top: 20vh;\n    text-align: center;\n}\n.tenant-administrator-invoice-details-invoice-payment-loading-account-container div{\n    height: 32px;\n    width: 32px;\n    display: inline-block;\n    border-radius: 50%;\n    border: 2px solid rgba(155, 30, 30, 0.952);\n    border-top-color: transparent;\n    animation: tenant-administrator-invoice-details-invoice-payment-loading-account-spinner 0.8s linear infinite;\n}\n@keyframes tenant-administrator-invoice-details-invoice-payment-loading-account-spinner {\n    from{\n        transform: rotate(0deg);\n    }\n    to{\n        transform: rotate(360deg);\n    }\n}\n.tenant-administrator-invoice-details-invoice-payment-loading-account-container p{\n    color: rgb(48, 48, 48);\n    font-family: 'Segoe UI', Tahoma, Geneva, Verdana, sans-serif;\n}\n/* #endregion */\n/* #region Insufficient funds */\n.tenant-administrator-invoice-details-invoice-payment-insufficient-funds-container{\n    text-align: left;\n    display: inline-block;\n    margin-top: 10vh;\n    padding: 15px 20px;\n    border-radius: 4px;\n    box-shadow: 0px 8px 16px rgba(0, 0, 0, 0.2);\n}\n.tenant-administrator-invoice-details-invoice-payment-insufficient-funds-container p{\n    margin: 4px 0px;\n    font-size: 16px;\n    font-family: 'Segoe UI', Tahoma, Geneva, Verdana, sans-serif;\n}\n.tenant-administrator-invoice-details-invoice-payment-insufficient-funds-container div{\n    padding-top: 12px;\n    padding-bottom: 5px;\n    display: flex;\n    justify-content: space-between;\n}\n.tenant-administrator-invoice-details-invoice-payment-insufficient-funds-container div button{\n    padding: 8px 16px;\n    cursor: pointer;\n    border: none;\n    border-radius: 4px;\n    color: white;\n    background-color: rgba(155, 30, 30, 0.952);\n    transition: background-color 0.25s ease-in;\n}\n.tenant-administrator-invoice-details-invoice-payment-insufficient-funds-container div button:hover{\n    background-color: rgb(199, 16, 16);\n}\n/* #endregion */\n/* #region Payment confirmation*/\n.tenant-administrator-invoice-details-invoice-payment-confirmation-container{\n    text-align: center;\n}\n.tenant-administrator-invoice-details-invoice-payment-confirmation-container .details-parent-container{\n    margin-top: 5vh;\n    display: inline-block;\n    padding: 16px 25px;\n    border-radius: 5px;\n    box-shadow: 0px 8px 16px rgba(0, 0, 0, 0.2);\n}\n.tenant-administrator-invoice-details-invoice-payment-confirmation-container .details-parent-container p{\n    font-size: 15px;\n    color: rgb(50, 50, 50);\n    font-family: Verdana, Geneva, Tahoma, sans-serif;\n}\n.tenant-administrator-invoice-details-invoice-payment-confirmation-container .details-container{\n    text-align: left;\n    cursor: default;\n    display: grid;\n    row-gap: 4px;\n    grid-template-columns: 200px 1fr;\n    font-family: 'Segoe UI', Tahoma, Geneva, Verdana, sans-serif;\n}\n.tenant-administrator-invoice-details-invoice-payment-confirmation-container .details-container strong{\n    font-weight: 500;\n    color: rgb(48, 48, 48);\n}\n.tenant-administrator-invoice-details-invoice-payment-confirmation-container .details-container span{\n    color: rgb(32, 32, 32);\n    text-align: right;\n}\n.tenant-administrator-invoice-details-invoice-payment-confirmation-container .details-container strong.total,\n.tenant-administrator-invoice-details-invoice-payment-confirmation-container .details-container span.total{\n    padding: 4px 0px;\n    border-top: 1px solid rgb(190, 190, 190);\n    border-bottom: 1px solid rgb(190, 190, 190);\n}\n.tenant-administrator-invoice-details-invoice-payment-confirmation-container .details-container strong.available-balance,\n.tenant-administrator-invoice-details-invoice-payment-confirmation-container .details-container span.available-balance{\n    margin-top: 10px;\n}\n.tenant-administrator-invoice-details-invoice-payment-confirmation-container .details-container strong.remaining-balance,\n.tenant-administrator-invoice-details-invoice-payment-confirmation-container .details-container span.remaining-balance{\n    color: rgb(34, 102, 34);\n}\n.tenant-administrator-invoice-details-invoice-payment-confirmation-container .buttons-container{\n    padding: 5px 0px;\n    padding-top: 20px;\n    display: flex;\n    justify-content: space-between;\n}\n.tenant-administrator-invoice-details-invoice-payment-confirmation-container .buttons-container button{\n    padding: 8px 16px;\n    cursor: pointer;\n    border: none;\n    border-radius: 4px;\n    color: white;\n    background-color: rgba(155, 30, 30, 0.952);\n    transition: background-color 0.25s ease-in;\n}\n.tenant-administrator-invoice-details-invoice-payment-confirmation-container .buttons-container button:hover{\n    background-color: rgb(199, 16, 16);\n}\n/* #endregion*/\n/* #region Processing payment*/\n.tenant-administrator-invoice-details-processing-invoice-payment-container{\n    cursor: default;\n    margin-top: 20vh;\n    text-align: center;\n}\n.tenant-administrator-invoice-details-processing-invoice-payment-container div{\n    height: 32px;\n    width: 32px;\n    display: inline-block;\n    border-radius: 50%;\n    border: 2px solid rgba(155, 30, 30, 0.952);\n    border-top-color: transparent;\n    animation: tenant-administrator-invoice-details-processing-invoice-payment-spinner 0.8s linear infinite;\n}\n@keyframes tenant-administrator-invoice-details-processing-invoice-payment-spinner {\n    from{\n        transform: rotate(0deg);\n    }\n    to{\n        transform: rotate(360deg);\n    }\n}\n.tenant-administrator-invoice-details-processing-invoice-payment-container p{\n    color: rgb(48, 48, 48);\n    font-family: 'Segoe UI', Tahoma, Geneva, Verdana, sans-serif;\n}\n/* #endregion*/\n/* #region Invoice payment processed*/\n.tenant-administrator-invoice-details-invoice-payment-processed-container{\n    margin-top: 10vh;\n    display: inline-block;\n    border-radius: 4px;\n    padding: 10px 20px;\n    box-shadow: 0px 8px 16px rgba(0, 0, 0, 0.2);\n}\n.tenant-administrator-invoice-details-invoice-payment-processed-container p{\n    margin: 15px 0px;\n    font-size: 15px;\n    color: rgb(48, 48, 48);\n    font-family: 'Segoe UI', Tahoma, Geneva, Verdana, sans-serif;\n}\n.tenant-administrator-invoice-details-invoice-payment-processed-container div{\n    display: flex;\n    justify-content: space-between;\n    padding-top: 5px;\n    padding-bottom: 10px;\n}\n.tenant-administrator-invoice-details-invoice-payment-processed-container div button{\n    padding: 8px 16px;\n    cursor: pointer;\n    border: none;\n    border-radius: 4px;\n    color: white;\n    background-color: rgba(155, 30, 30, 0.952);\n    transition: background-color 0.25s ease-in;\n}\n.tenant-administrator-invoice-details-invoice-payment-processed-container div button:hover{\n    background-color: rgba(204, 38, 38, 0.952);\n}\n/* #endregion*/\n/* #region Invoice payment processing error*/\n.tenant-administrator-invoice-details-invoice-payment-processing-error-container{\n    margin-top: 10vh;\n    display: inline-block;\n    border-radius: 4px;\n    padding: 10px 20px;\n    box-shadow: 0px 8px 16px rgba(0, 0, 0, 0.2);\n}\n.tenant-administrator-invoice-details-invoice-payment-processing-error-container p{\n    font-size: 15px;\n    color: rgb(48, 48, 48);\n    font-family: 'Segoe UI', Tahoma, Geneva, Verdana, sans-serif;\n}\n.tenant-administrator-invoice-details-invoice-payment-processing-error-container div{\n    text-align: right;\n    margin-bottom: 10px;\n}\n.tenant-administrator-invoice-details-invoice-payment-processing-error-container div button{\n    padding: 8px 16px;\n    cursor: pointer;\n    border: none;\n    border-radius: 4px;\n    color: white;\n    background-color: rgba(155, 30, 30, 0.952);\n    transition: background-color 0.25s ease-in;\n}\n.tenant-administrator-invoice-details-invoice-payment-processing-error-container div button:hover{\n    background-color: rgba(204, 38, 38, 0.952);\n}\n/* #endregion*/\n/* #region Invoice payment reversing*/\n.tenant-administrator-invoice-details-invoice-payment-reversing-container{\n    cursor: default;\n    margin-top: 20vh;\n    text-align: center;\n}\n.tenant-administrator-invoice-details-invoice-payment-reversing-container div{\n    height: 32px;\n    width: 32px;\n    display: inline-block;\n    border-radius: 50%;\n    border: 2px solid rgba(155, 30, 30, 0.952);\n    border-top-color: transparent;\n    animation: tenant-administrator-invoice-details-invoice-payment-reversing-spinner 0.8s linear infinite;\n}\n@keyframes tenant-administrator-invoice-details-invoice-payment-reversing-spinner {\n    from{\n        transform: rotate(0deg);\n    }\n    to{\n        transform: rotate(360deg);\n    }\n}\n.tenant-administrator-invoice-details-invoice-payment-reversing-container p{\n    color: rgb(48, 48, 48);\n    font-family: 'Segoe UI', Tahoma, Geneva, Verdana, sans-serif;\n}\n/* #endregion*/\n/* #region Invoice payment reversed*/\n.tenant-administrator-invoice-details-invoice-payment-reversed-container{\n    margin-top: 10vh;\n    display: inline-block;\n    border-radius: 4px;\n    padding: 10px 20px;\n    box-shadow: 0px 8px 16px rgba(0, 0, 0, 0.2);\n}\n.tenant-administrator-invoice-details-invoice-payment-reversed-container p{\n    font-size: 15px;\n    color: rgb(48, 48, 48);\n    font-family: 'Segoe UI', Tahoma, Geneva, Verdana, sans-serif;\n}\n.tenant-administrator-invoice-details-invoice-payment-reversed-container div{\n    text-align: right;\n}\n.tenant-administrator-invoice-details-invoice-payment-reversed-container div button{\n    padding: 8px 16px;\n    cursor: pointer;\n    border: none;\n    border-radius: 4px;\n    color: white;\n    background-color: rgba(155, 30, 30, 0.952);\n    transition: background-color 0.25s ease-in;\n}\n.tenant-administrator-invoice-details-invoice-payment-reversed-container div button:hover{\n    background-color: rgba(204, 38, 38, 0.952);\n}\n/* #endregion*/\n/* #region Invoice payment reverse error*/\n.tenant-administrator-invoice-details-invoice-payment-reverse-error-container{\n    margin-top: 10vh;\n    display: inline-block;\n    border-radius: 4px;\n    padding: 10px 20px;\n    box-shadow: 0px 8px 16px rgba(0, 0, 0, 0.2);\n}\n.tenant-administrator-invoice-details-invoice-payment-reverse-error-container p{\n    font-size: 15px;\n    color: rgb(48, 48, 48);\n    font-family: 'Segoe UI', Tahoma, Geneva, Verdana, sans-serif;\n}\n.tenant-administrator-invoice-details-invoice-payment-reverse-error-container div{\n    text-align: right;\n    padding-bottom: 5px;\n}\n.tenant-administrator-invoice-details-invoice-payment-reverse-error-container div button{\n    padding: 8px 16px;\n    cursor: pointer;\n    border: none;\n    border-radius: 4px;\n    color: white;\n    background-color: rgba(155, 30, 30, 0.952);\n    transition: background-color 0.25s ease-in;\n}\n.tenant-administrator-invoice-details-invoice-payment-reverse-error-container div button:hover{\n    background-color: rgba(204, 38, 38, 0.952);\n}\n/* #endregion*/\n/* #endregion */\n\n\n.tenant-administrator-invoice-details-parent-navigation-bar{\n    text-align: center;\n    padding: 8px 0px;\n    padding-bottom: 16px;\n}\n.tenant-administrator-invoice-details-parent-navigation-bar div{\n    width: 70%;\n    text-align: left;\n    display: inline-block;\n}\n.tenant-administrator-invoice-details-parent-navigation-bar button{\n    margin-right: 16px;\n    padding: 6px 12px;\n    border: none;\n    color: white;\n    border-radius: 5px;\n    cursor: pointer;\n    background-color: rgba(155, 30, 30, 0.952);\n}\n.tenant-administrator-invoice-details-container{\n    position: relative;\n    height: 60vh;\n    width: 70%;\n    text-align: left;\n    display: inline-block;\n    overflow: hidden;\n    box-shadow: 0px 2px 8px 0px rgba(0, 0, 0, 0.2);\n}\n.tenant-administrator-invoice-details-edit-mask-container{\n    position: absolute;\n    z-index: 2;\n    top: 0;\n    left: 0;\n    height: 100%;\n    width: 100%;\n    cursor: default;\n    display: block;\n    background-color: rgba(255, 255, 255, 0.5);\n}\n.tenant-administrator-invoice-details-edit-mask-container.hidden{\n    display: none;\n}\n.tenant-administrator-invoice-details-navigation-bar{\n    margin: 0px 25px;\n    border-bottom: 1px solid rgb(226, 226, 226);\n}\n.tenant-administrator-invoice-details-navigation-bar button{\n    border: none;\n    padding: 0px 10px;\n    padding-top: 10px;\n    padding-bottom: 5px;\n    cursor: pointer;\n    color: rgb(100, 100, 100);\n    font-size: 15px;\n    font-weight: 500;\n    font-family: 'Segoe UI', Tahoma, Geneva, Verdana, sans-serif;\n    background-color: transparent;\n}\n.tenant-administrator-invoice-details-navigation-bar button.active{\n    color: rgba(155, 30, 30, 0.952);\n    border-bottom: 2px solid rgba(155, 30, 30, 0.952);\n}\n.tenant-administrator-invoice-details-primary-details-container{\n    position: absolute;\n    height: 90%;\n    width: 100%;\n    overflow: auto;\n    padding: 10px 25px;\n    padding-top: 0px;\n    box-sizing: border-box;\n}\n.tenant-administrator-invoice-details-primary-details-container::-webkit-scrollbar{\n    width: 4px;\n}\n.tenant-administrator-invoice-details-primary-details-container::-webkit-scrollbar-thumb{\n    background-color: rgb(145, 145, 145);\n    border-radius: 5px;\n}\n.tenant-administrator-invoice-details-primary-details-container.active{\n    animation: tenant-administrator-invoice-details-primary-details-container-slide-in 0.5s ease-out forwards;\n}\n.tenant-administrator-invoice-details-primary-details-container.inactive{\n    animation: tenant-administrator-invoice-details-primary-details-container-slide-out 0.5s ease-out forwards;\n}\n@keyframes tenant-administrator-invoice-details-primary-details-container-slide-in {\n    from{\n        opacity: 0;\n        transform: translateX(100%);\n    }\n    to{\n        opacity: 1;\n        z-index: 1;\n        transform: translateX(0);\n    }\n}\n@keyframes tenant-administrator-invoice-details-primary-details-container-slide-out {\n    from{\n        opacity: 1;\n        transform: translateX(0);\n    }\n    to{\n        opacity: 0;\n        z-index: 0;\n        transform: translateX(110%);\n    }\n}\n.tenant-administrator-invoice-details-entry-container{\n    position: relative;\n    margin: 20px 0px;\n    padding: 4px 10px;\n    box-sizing: border-box;\n    border-bottom: 1px solid gray;\n    border-radius: 2px 2px 0px 0px;\n    background-color: rgba(222, 229, 233,0.6);\n}\n.tenant-administrator-invoice-details-entry-container:focus-within{\n    border-bottom: 2px solid rgb(119, 12, 12);\n    background-color: rgb(221, 232, 238);\n}\n.tenant-administrator-invoice-details-entry-container p{\n    margin: 0px;\n    font-size: 12px;\n    cursor: default;\n}\n.tenant-administrator-invoice-details-entry-container span{\n    color: red;\n}\n.tenant-administrator-invoice-details-entry-container input{\n    width: 100%;\n    outline: none;\n    border: none;\n    box-sizing: border-box;\n    background-color: transparent;\n}\n.tenant-administrator-invoice-details-selected-customer-account-container{\n    display: flex;\n    align-items: center;\n    justify-content: space-between;\n}\n.tenant-administrator-invoice-details-selected-customer-account-container p{\n    cursor: default;\n    font-size: 14px;\n}\n.tenant-administrator-invoice-details-selected-customer-account-container p span{\n    cursor: pointer;\n    margin-left: 16px;\n    color: rgb(80, 80, 80);\n}\n.tenant-administrator-invoice-details-customer-account-browser{\n    position: absolute;\n    top: calc(100% + 2px);\n    left: 0;\n    width: 100%;\n    max-height: 94px;\n    z-index: 1;\n    display: none;\n    overflow: auto;\n    box-sizing: border-box;\n    background-color: white;\n    box-shadow: 0px 4px 4px 0px rgba(0, 0, 0, 0.2);\n}\n.tenant-administrator-invoice-details-customer-account-browser.active{\n    display: block;\n}\n.tenant-administrator-invoice-details-customer-account-browser div{\n    display: flex;\n    align-items: center;\n    justify-content: space-between;\n    font-size: 14px;\n    padding: 10px 10px;\n    cursor: pointer;\n}\n.tenant-administrator-invoice-details-customer-account-browser div:hover{\n    background-color: rgb(243, 243, 243);\n}\n.tenant-administrator-invoice-details-selected-duration-type-container{\n    display: flex;\n    justify-content: space-between;\n}\n.tenant-administrator-invoice-details-selected-duration-type-container p{\n    margin: 2px 0px;\n    font-size: 14px;\n}\n.tenant-administrator-invoice-details-selected-duration-type-container .cancel-p{\n    cursor: pointer;\n    color: rgb(80, 80, 80);\n}\n.tenant-administrator-invoice-details-duration-type-browser{\n    position: absolute;\n    top: calc(100% + 2px);\n    left: 0;\n    width: 100%;\n    z-index: 1;\n    max-height: 104px;\n    display: none;\n    overflow: auto;\n    box-sizing: border-box;\n    background-color: white;\n    box-shadow: 0px 4px 4px 0px rgba(0, 0, 0, 0.2);\n}\n.tenant-administrator-invoice-details-duration-type-browser.active{\n    display: block;\n}\n.tenant-administrator-invoice-details-duration-type-browser div{\n    cursor: pointer;\n    font-size: 14px;\n    padding: 8px 10px;\n}\n.tenant-administrator-invoice-details-duration-type-browser div:hover{\n    background-color: rgb(243, 243, 243);\n}\n.tenant-administrator-invoice-details-duration-type-browser::-webkit-scrollbar{\n    width: 4px;\n}\n.tenant-administrator-invoice-details-duration-type-browser::-webkit-scrollbar-thumb{\n    border-radius: 5px;\n    background-color: rgb(100, 100, 100);\n}\n.tenant-administrator-invoice-details-autogenerate-container{\n    display: flex;\n    align-items: center;\n    margin-top: -5px;\n    padding: 0px 5px;\n    padding-bottom: 15px;\n}\n.tenant-administrator-invoice-details-autogenerate-container p{\n    margin: 0px;\n    margin-bottom: 4px;\n    font-size: 14px;\n}\n.tenant-administrator-invoice-details-notes-container{\n    padding: 10px;\n    height: 15vh;\n    display: flex;\n    flex-direction: column;\n    box-shadow: 0px 4px 8px 0px rgba(0, 0, 0, 0.2);\n}\n.tenant-administrator-invoice-details-notes-header{\n    display: flex;\n    align-items: center;\n    justify-content: space-between;\n    border-bottom: 1px solid lightgray;\n}\n.tenant-administrator-invoice-details-notes-header h3{\n    margin: 0px 15px;\n    font-size: 20px;\n    font-weight: 500;\n    cursor: default;\n    color: rgb(100, 100, 100);\n}\n.tenant-administrator-invoice-details-notes-header p{\n    margin: 0px 15px;\n    font-size: 24px;\n    font-weight: 500;\n    cursor: pointer;\n    color: rgb(100, 100, 100);\n}\n.tenant-administrator-invoice-details-notes-body{\n    position: relative;\n    overflow: auto;\n    padding-top: 5px;\n}\n.tenant-administrator-invoice-details-notes-body::-webkit-scrollbar{\n    width: 4px;\n}\n.tenant-administrator-invoice-details-notes-body::-webkit-scrollbar-thumb{\n    border-radius: 5px;\n    background-color: rgb(128, 128, 128);\n}\n.tenant-administrator-invoice-details-notes-body div{\n    display: flex;\n    padding: 5px 0px;\n    margin: 5px 10px;\n    border-radius: 4px;\n}\n.tenant-administrator-invoice-details-notes-body div.empty{\n    border: 1px solid rgba(247, 0, 0, 0.507);\n}\n.tenant-administrator-invoice-details-notes-body div p{\n    margin: 0px;\n    margin-left: 5px;\n}\n.tenant-administrator-invoice-details-notes-body div input{\n    width: 80%;\n    margin-left: 10px;\n    margin-right: 40px;\n    border: none;\n    outline: none;\n}\n.tenant-administrator-invoice-details-notes-body img{\n    height: 20px;\n    cursor: pointer;\n}\n\n.tenant-administrator-invoice-details-subscriptions-container{\n    position: absolute;\n    height: 50vh;\n    width: calc(100% - 50px);\n    margin: 10px 25px;\n    padding: 10px 15px;\n    box-sizing: border-box;\n    box-shadow: 0px 2px 8px 0px rgba(0, 0, 0, 0.1);\n}\n.tenant-administrator-invoice-details-subscriptions-container.default{\n    opacity: 0;\n    z-index: 0;\n    transform: translateX(110%);\n}\n.tenant-administrator-invoice-details-subscriptions-container.active{\n    animation: tenant-administrator-invoice-details-subscriptions-container-slide-in 0.5s ease-out forwards;\n}\n.tenant-administrator-invoice-details-subscriptions-container.inactive{\n    animation: tenant-administrator-invoice-details-subscriptions-container-slide-out 0.5s ease-out forwards;\n}\n@keyframes tenant-administrator-invoice-details-subscriptions-container-slide-in {\n    from{\n        opacity: 0;\n        transform: translateX(100%);\n    }\n    to{\n        opacity: 1;\n        z-index: 1;\n        transform: translateX(0);\n    }\n}\n\n@keyframes tenant-administrator-invoice-details-subscriptions-container-slide-out {\n    from{\n        opacity: 1;\n        transform: translateX(0);\n    }\n    to{\n        opacity: 0;\n        transform: translateX(110%);\n    }\n}\n.tenant-administrator-invoice-details-subscriptions-header{\n    padding-bottom: 5px;\n    display: flex;\n    align-items: center;\n    justify-content: space-between;\n    border-bottom: 1px solid rgb(240, 240, 240);\n}\n.tenant-administrator-invoice-details-subscriptions-header h3{\n    margin: 0px;\n    font-size: 20px;\n    font-weight: 500;\n    cursor: default;\n    color: rgb(100, 100, 100);\n}\n.tenant-administrator-invoice-details-subscriptions-header p{\n    margin: 0px;\n    font-size: 24px;\n    font-weight: 500;\n    cursor: pointer;\n    color: rgb(100, 100, 100);\n}\n.tenant-administrator-invoice-details-subscriptions-body{\n    height: 100%;\n}\n.tenant-administrator-invoice-details-subscriptions-no-duration-type-parent-container{\n    height: 80%;\n    display: flex;\n    align-items: center;\n    justify-content: center;\n    color: rgb(48, 48, 48);\n}\n.tenant-administrator-invoice-details-subscriptions-no-duration-type-container h2{\n    font-weight: 500;\n    font-size: 20px;\n    text-align: center;\n    margin: 10px 0px;\n}\n.tenant-administrator-invoice-details-subscriptions-no-duration-type-container p{\n    font-size: 15px;\n    margin: 0px;\n}\n.tenant-administrator-invoice-details-loading-available-subscriptions-parent-container{\n    height: 80%;\n    display: flex;\n    align-items: center;\n    justify-content: center;\n}\n.tenant-administrator-invoice-details-loading-available-subscriptions-container{\n    text-align: center;\n}\n.tenant-administrator-invoice-details-loading-available-subscriptions-container div{\n    width: 32px;\n    height: 32px;\n    display: inline-block;\n    border: 2px solid rgba(0, 58, 97, 0.952);\n    border-top-color: transparent;\n    border-radius: 50%;\n    animation: tenant-administrator-invoice-details-loading-available-subscriptions-spinner 1s linear infinite;\n}\n@keyframes tenant-administrator-invoice-details-loading-available-subscriptions-spinner {\n    from{\n        transform: rotate(0deg);\n    }\n    to{\n        transform: rotate(360deg);\n    }\n}\n.tenant-administrator-invoice-details-subscription-entries-container{\n    height: 90%;\n    overflow: auto;\n}\n.tenant-administrator-invoice-details-subscription-entries-container::-webkit-scrollbar{\n    width: 4px;\n}\n.tenant-administrator-invoice-details-subscription-entries-container::-webkit-scrollbar-thumb{\n    border-radius: 5px;\n    background-color: gray;\n}\n.tenant-administrator-invoice-details-subscription-entry-container{\n    display: flex;\n    align-items: center;\n    padding: 10px;\n}\n.tenant-administrator-invoice-details-subscription-entry-sub-container{\n    width: 100%;\n    position: relative;\n}\n.tenant-administrator-invoice-details-subscription-entry-value-container{\n    display: grid;\n    grid-template-columns: 4fr 1fr;\n    padding: 4px 0px;\n    border-bottom: 1px solid rgb(218, 218, 218);\n}\n.tenant-administrator-invoice-details-subscription-entry-value-container p{\n    margin: 0px;\n    cursor: default;\n    font-size: 14px;\n}\n.tenant-administrator-invoice-details-subscription-entry-value-container div{\n    display: flex;\n    align-items: center;\n    justify-content: space-between;\n}\n.tenant-administrator-invoice-details-subscription-entry-value-container div .remove-p{\n    cursor: pointer;\n    color: rgb(85, 85, 85);\n}\n.tenant-administrator-invoice-details-subscription-entry-container input{\n    width: 100%;\n    outline: none;\n    border: none;\n    box-sizing: border-box;\n    border-bottom: 1px solid rgb(190, 190, 190);\n}\n.tenant-administrator-invoice-details-subscription-entry-container input:focus{\n    border-bottom: 1px solid rgba(180, 0, 0, 0.507);\n}\n.tenant-administrator-invoice-details-subscription-entry-container img{\n    height: 25px;\n    margin-left: 10px;\n    cursor: pointer;\n}\n.tenant-administrator-invoice-details-subscriptions-browser{\n    position: absolute;\n    z-index: 1;\n    top: calc(100% + 2px);\n    left: 0;\n    width: 100%;\n    max-height: 16.5vh;\n    display: none;\n    overflow: auto;\n    box-sizing: border-box;\n    background-color: white;\n    box-shadow: 0px 2px 4px 0px rgba(0, 0, 0, 0.2);\n}\n.tenant-administrator-invoice-details-subscriptions-browser::-webkit-scrollbar{\n    width: 4px;\n}\n.tenant-administrator-invoice-details-subscriptions-browser::-webkit-scrollbar-thumb{\n    border-radius: 5px;\n    background-color: rgb(128, 128, 128);\n}\n.tenant-administrator-invoice-details-subscriptions-browser.active{\n    display: block;\n}\n.tenant-administrator-invoice-details-subscriptions-browser div{\n    cursor: pointer;\n    display: grid;\n    grid-template-columns: 4fr 1fr;\n    border-bottom: 1px solid rgb(235, 235, 235);\n}\n.tenant-administrator-invoice-details-subscriptions-browser div:hover{\n    background-color: rgb(235, 235, 235);\n}\n.tenant-administrator-invoice-details-subscriptions-browser div p{\n    margin: 6px 10px;\n    font-size: 14px;\n    color: rgb(48, 48, 48);\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
